// extracted by mini-css-extract-plugin
export var noSpinners = "_nv-6";
export var percentageInput = "_nv-7";
export var variantColor1 = "_nv-0";
export var variantColor2 = "_nv-1";
export var variantColor3 = "_nv-2";
export var variantColor4 = "_nv-3";
export var variantColor5 = "_nv-4";
export var variantColor6 = "_nv-5";